import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, url }) => {
  const siteTitle = "TusciaHub | Il Portale degli Studenti a Viterbo";
  const defaultDesc = "TusciaHub è la piattaforma indipendente per gli studenti universitari a Viterbo. Trova appunti, affitti, tutor, offerte di lavoro ed eventi.";
  const siteUrl = "https://tusciahub.it";
  const currentUrl = url ? `${siteUrl}${url}` : siteUrl;

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{title ? `${title} | TusciaHub` : siteTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook / WhatsApp */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title ? `${title} | TusciaHub` : siteTitle} />
      <meta property="og:description" content={description || defaultDesc} />
      <meta property="og:image" content={`${siteUrl}/logo512.png`} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title ? `${title} | TusciaHub` : siteTitle} />
      <meta name="twitter:description" content={description || defaultDesc} />
      <meta name="twitter:image" content={`${siteUrl}/logo512.png`} />
    </Helmet>
  );
};

export default SEO;